import { useEffect } from 'react';

import { IEmergencyBannerFragment } from 'generated/sanity-graphql';
import { useEmergencyBannerContext } from 'state/emergency-banner';

const useEmergencyBannerPageComponent = (components: ReadonlyArray<any>) => {
  const { setShouldShowEmergencyBanner, setText } = useEmergencyBannerContext();

  useEffect(() => {
    if (components) {
      const emergencyBanner = components?.find(
        component => component?.__typename === 'EmergencyBanner'
      );

      if (emergencyBanner) {
        setShouldShowEmergencyBanner(true);
        setText((emergencyBanner as IEmergencyBannerFragment)?.text?.locale);
      }
    }

    return () => {
      setShouldShowEmergencyBanner(false);
      setText(undefined);
    };
  }, [components, setText, setShouldShowEmergencyBanner]);
};

export default useEmergencyBannerPageComponent;
